import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import Container from 'components/v2/container';
import { getYards } from 'utils/YardAPIUtils';
import { YardNav } from './YardNav';
import { ITEMS_PER_PAGE_LIMIT } from './constants';

export function withYardLayout(activeTab, wrappedComponent) {
  return function () {
    const params = useParams();
    const yardId = params.id;
    const { t } = useTranslation();
    const isNewYard = yardId === 'new';

    const [loading, setLoading] = useState(true);
    const [currentYard, setCurrentYard] = useState();
    const breadcrumbs = {
      pages: [
        { name: t('YARD_other', { count: 3 }), href: '/yards', current: false },
        {
          name: isNewYard ? t('NEW_YARD') : currentYard?.nameInternal || '',
          href: '#',
          current: true,
        },
      ],
    };

    async function fetchData() {
      const {
        data: { getYards: data },
      } = await getYards('nameInternal', 'ascend', null, ITEMS_PER_PAGE_LIMIT, {
        id: isNewYard ? null : yardId,
        marketId: null,
        nameInternal: null,
        status: null,
      });

      if (data && data.yards) {
        const yard = data.yards.find((yard) => yard.id === yardId);

        if (yard) {
          setCurrentYard(yard);
          setLoading(false);
        } else if (isNewYard) {
          setLoading(false);
        }
      }
    }

    useEffect(() => {
      fetchData();
    }, [yardId]);

    function renderSidebar() {
      return <YardNav activeTab={activeTab} id={yardId} />;
    }

    function handleOnUpdate() {
      fetchData();
    }

    const Component = wrappedComponent;

    return (
      <>
        {!loading && (
          <LayoutWithSidebar
            className="pt-3"
            sidebar={renderSidebar}
            breadcrumbs={breadcrumbs}
          >
            {Component && (
              <Component
                yard={currentYard}
                isNewYard={isNewYard}
                onUpdate={handleOnUpdate}
              />
            )}
          </LayoutWithSidebar>
        )}
        {loading && (
          <Container className="py-10">
            <p className="lead">{titleize(t('LOADING'))}</p>
          </Container>
        )}
      </>
    );
  };
}
